/* eslint-disable */
// this is an auto generated file. This will be overwritten
export const listClients = `query ListClients(
  $filter: ModelClientFilterInput
  $limit: Int
  $nextToken: String
) {
  listClients(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      code
      name
      description
      logo
      website
      email
      address
      phoneno
      accounts {
        nextToken
      }
      features {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdated
      version
    }
    nextToken
  }
}
`;

// Stream Router Interface Queries
export const listStreamRouterInterfacesConnections = `query ListStreamRouterInterfacesConnections($streamRouterId: String!) {
  listStreamRouterInterfacesConnections(streamRouterId: $streamRouterId) {
    success
    message
    dataJson
  }
}
`;

export const getStreamRouterInterfaceConnections = `query GetStreamRouterInterfaceConnections($streamRouterId: String!, $interfaceId: String!) {
  getStreamRouterInterfaceConnections(streamRouterId: $streamRouterId, interfaceId: $interfaceId) {
    success
    message
    dataJson
  }
}
`;

export const listStreamRouterInterfaces = `query ListStreamRouterInterfaces($streamRouterId: String!) {
  listStreamRouterInterfaces(streamRouterId: $streamRouterId) {
    success
    message
    dataJson
  }
}
`;

export const getStreamRouterInterface = `query GetStreamRouterInterface($streamRouterId: String!, $interfaceId: String!) {
  getStreamRouterInterface(streamRouterId: $streamRouterId, interfaceId: $interfaceId) {
    success
    message
    dataJson
  }
}
`;

export const getStreamRouterInterfaceStatus = `query GetStreamRouterInterfaceStatus($streamRouterId: String!, $interfaceId: String!) {
  getStreamRouterInterfaceStatus(streamRouterId: $streamRouterId, interfaceId: $interfaceId) {
    success
    message
    dataJson
  }
}
`;

// Wowza Queries
export const listWowzaApplications = `query ListWowzaApplications($serverId: String!) {
  listWowzaApplications(serverId: $serverId) {
    success
    message
    dataJson
  }
}
`;

export const getWowzaApplication = `query GetWowzaApplication($serverId: String!, $applicationId: String!) {
  getWowzaApplication(serverId: $serverId, applicationId: $applicationId) {
    success
    message
    dataJson
  }
}
`;

export const listWowzaAppTargets = `query ListWowzaAppTargets($serverId: String!, $applicationId: String!) {
  listWowzaAppTargets(serverId: $serverId, applicationId: $applicationId) {
    success
    message
    dataJson
  }
}
`;

export const getWowzaAppTarget = `query GetWowzaAppTarget($serverId: String!, $applicationId: String!, $targetId: String!) {
  getWowzaAppTarget(serverId: $serverId, applicationId: $applicationId, targetId: $targetId) {
    success
    message
    dataJson
  }
}
`;